const menus = [
  {
    'context': [
      'points',
      'cash'
    ],
    'items': [
      {
        'items': [
          {
            'path': '/search?subcategory=9',
            'label': 'Acessórios Elétricos',
            'enabled': true
          },
          {
            'path': '/search?subcategory=10',
            'label': 'Acessórios Internos',
            'enabled': true
          },
          {
            'path': '/search?subcategory=6',
            'label': 'Acessórios para Motos',
            'enabled': true
          },
          {
            'path': '/search?subcategory=11',
            'label': 'Ferramentas e Peças Automotivas',
            'enabled': true
          },
          {
            'path': '/search?subcategory=12',
            'label': 'Gps e Acessórios',
            'enabled': true
          },
          {
            'path': '/search?subcategory=7',
            'label': 'Iluminação',
            'enabled': true
          },
          {
            'path': '/search?subcategory=13',
            'label': 'Limpeza',
            'enabled': true
          },
          {
            'path': '/search?subcategory=14',
            'label': 'Óleos e Flupathos',
            'enabled': true
          },
          {
            'path': '/search?subcategory=15',
            'label': 'Pneus para Carros',
            'enabled': true
          },
          {
            'path': '/search?subcategory=16',
            'label': 'Pneus para Motos',
            'enabled': true
          },
          {
            'path': '/search?subcategory=17',
            'label': 'Racks e Suportes',
            'enabled': true
          },
          {
            'path': '/search?subcategory=18',
            'label': 'Segurança',
            'enabled': true
          },
          {
            'path': '/search?subcategory=8',
            'label': 'Som Automotivo',
            'enabled': true
          }
        ],
        'path': '/search?category=2',
        'label': 'Automotivo',
        'enabled': true
      },
      {
        'items': [
          {
            'path': '/search?subcategory=19',
            'label': 'Acessórios para Bebês',
            'enabled': true
          },
          {
            'path': '/search?subcategory=20',
            'label': 'Alimentação',
            'enabled': true
          },
          {
            'path': '/search?subcategory=21',
            'label': 'Banho, Higiene e Saúde',
            'enabled': true
          },
          {
            'path': '/search?subcategory=22',
            'label': 'Berçário, Berços e Cercados',
            'enabled': true
          },
          {
            'path': '/search?subcategory=24',
            'label': 'Carrinhos para bebê',
            'enabled': true
          },
          {
            'path': '/search?subcategory=25',
            'label': 'Chupetas e Mordedores',
            'enabled': true
          },
          {
            'path': '/search?subcategory=26',
            'label': 'Enxoval',
            'enabled': true
          },
          {
            'path': '/search?subcategory=27',
            'label': 'Para a Mamãe',
            'enabled': true
          },
          {
            'path': '/search?subcategory=29',
            'label': 'Segurança para bebê',
            'enabled': true
          }
        ],
        'path': '/search?category=3',
        'label': 'Bebês',
        'enabled': true
      },
      {
        'items': [
          {
            'path': '/search?subcategory=30',
            'label': 'Beleza',
            'enabled': true
          },
          {
            'path': '/search?subcategory=31',
            'label': 'Cupathado da Saúde',
            'enabled': true
          },
          {
            'path': '/search?subcategory=32',
            'label': 'Esportes e Fitness',
            'enabled': true
          },
          {
            'path': '/search?subcategory=34',
            'label': 'Perfumaria',
            'enabled': true
          }
        ],
        'path': '/search?category=4',
        'label': 'Bem estar',
        'enabled': true
      },
      {
        'items': [
          {
            'path': '/search?subcategory=36',
            'label': 'Cama, mesa e banho',
            'enabled': true
          },
          {
            'path': '/search?subcategory=37',
            'label': 'Casa e construção',
            'enabled': true
          },
          {
            'path': '/search?subcategory=38',
            'label': 'Eletrodomésticos',
            'enabled': true
          },
          {
            'path': '/search?subcategory=39',
            'label': 'Eletroportáteis',
            'enabled': true
          },
          {
            'path': '/search?subcategory=40',
            'label': 'Ferramentas',
            'enabled': true
          },
          {
            'path': '/search?subcategory=41',
            'label': 'Móveis, Decoração e Arte',
            'enabled': true
          },
          {
            'path': '/search?subcategory=42',
            'label': 'Utilpathade doméstica',
            'enabled': true
          }
        ],
        'path': '/search?category=5',
        'label': 'Casa e cozinha',
        'enabled': true
      },
      {
        'items': [
          {
            'path': '/search?subcategory=52',
            'label': 'Acessórios para eletrônicos',
            'enabled': true
          },
          {
            'path': '/search?subcategory=43',
            'label': 'Áudio',
            'enabled': true
          },
          {
            'path': '/search?subcategory=45',
            'label': 'Câmeras e acessórios',
            'enabled': true
          },
          {
            'path': '/search?subcategory=51',
            'label': 'Drones',
            'enabled': true
          },
          {
            'path': '/search?subcategory=47',
            'label': 'Informática',
            'enabled': true
          },
          {
            'path': '/search?subcategory=49',
            'label': 'Segurança para casa',
            'enabled': true
          },
          {
            'path': '/search?subcategory=48',
            'label': 'Telefones, Celulares e Tablets',
            'enabled': true
          },
          {
            'path': '/search?subcategory=46',
            'label': 'TV',
            'enabled': true
          },
          {
            'path': '/search?subcategory=44',
            'label': 'Vídeo',
            'enabled': true
          }
        ],
        'path': '/search?category=6',
        'label': 'Eletrônicos',
        'enabled': true
      },
      {
        'items': [
          {
            'path': '/search?subcategory=54',
            'label': 'Alimentos e bebpathas',
            'enabled': true
          },
          {
            'path': '/search?subcategory=55',
            'label': 'Linha Industrial',
            'enabled': true
          },
          {
            'path': '/search?subcategory=56',
            'label': 'Restaurantes',
            'enabled': true
          }
        ],
        'path': '/search?category=13',
        'label': 'Gastronomia',
        'enabled': true

      },
      {
        'items': [
          {
            'path': '/search?subcategory=1',
            'label': 'Equipamentos para escritório',
            'enabled': true
          },
          {
            'path': '/search?subcategory=5',
            'label': 'Equipamentos profissionais',
            'enabled': true
          },
          {
            'path': '/search?subcategory=3',
            'label': 'Indústria agropecuária',
            'enabled': true
          },
          {
            'path': '/search?subcategory=63',
            'label': 'Papelaria',
            'enabled': true
          }
        ],
        'path': '/search?category=1',
        'label': 'Indústria e Comércio',
        'enabled': true

      },
      {
        'items': [
          {
            'path': '/search?subcategory=58',
            'label': 'Brinquedos',
            'enabled': true
          },
          {
            'path': '/search?subcategory=57',
            'label': 'Cinema',
            'enabled': true
          },
          {
            'path': '/search?subcategory=65',
            'label': 'Educação',
            'enabled': true
          },
          {
            'path': '/search?subcategory=59',
            'label': 'Eventos',
            'enabled': true
          },
          {
            'path': '/search?subcategory=60',
            'label': 'Games',
            'enabled': true
          },
          {
            'path': '/search?subcategory=61',
            'label': 'Instrumentos Musicais',
            'enabled': true
          },
          {
            'path': '/search?subcategory=62',
            'label': 'Livros e Revistas',
            'enabled': true
          },
          {
            'path': '/search?subcategory=64',
            'label': 'Pet shop',
            'enabled': true
          }
        ],
        'path': '/search?category=7',
        'label': 'Lazer e Cultura',
        'enabled': true

      },
      {
        'items': [],
        'label': 'Doação',
        'path': '/donation',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Recarga de celular',
        'path': '/mobile-recharge',
        'enabled': true
      },
      {
        'items': [],
        'label': 'Ver todos os itens',
        'path': '/categories',
        'enabled': true
      }
    ],
    'label': 'Todos os departamentos',
    'enabled': true,
    'type': 'services'
  },
  {
    'context': [
      'points'
    ],
    'items': [
      {
        'items': [],
        'label': 'Milhas',
        'path': '/mileage',
        'enabled': true
      }
    ],
    'label': 'Viagens',
    'enabled': true,
    'type': 'services'
  },
  {
    'context': [
      'points'
    ],
    'items': [],
    'label': 'Vale Compras',
    'enabled': true,
    'type': 'dynamic',
    'dynamicAction': 'loadVouchersStores'
  }
]

export default menus



// WEBPACK FOOTER //
// ./src/redux/initial-state/categoryMenu.js